export const AmbientesEmpresas = {
    BRASIL: 'BR',
    PARAGUAY: 'PY',
    ARGENTINA: 'AR'
};
